import { Pba } from './pba';
import { SelectableTransaction } from './selectable-transaction';

export class PbaTransaction extends SelectableTransaction {
  pbas: Pba[];
}
